import { memo } from "react";
import { Icon } from "@/components/icons/Icon";

export interface PhasePillProps {
  phaseName: string;
}

const PHASE_COLOURS: Record<string, string> = {
  "Inspección desmontaje": "bg-ib-yellow-inpection",
  "Inspección MdP": "bg-ib-blue",
  "Reparación MdP": "bg-ib-orange-mdp",
  "Inspección CC": "bg-ib-purple",
};

const PhasePill = ({ phaseName = "" }: PhasePillProps) => {
  const colourClass = PHASE_COLOURS[phaseName] ?? "bg-ib-gray-borders";

  return (
    <div
      className={`h-6 w-fit px-2 flex flex-row gap-0.5 ${colourClass} rounded-[16px] items-center w-[125px]`}
    >
      <Icon name="rotateArrows" className="size-4 text-ib-black" />
      <span className="text-[12px] leading-[100%]">{phaseName}</span>
    </div>
  );
};

export default memo(PhasePill);
